{
  "deleteError": "Die Seite {pageName} (Kategorie-ID: {id}) konnte nicht gelöscht werden. {errorMessage}",
  "deleteSuccess": "Die Seite {pageName} (Kategorie-ID: {id}) wurde gelöscht.",
  "error": "Fehler beim Speichern der Kategorien.",
  "success": "Kategorien erfolgreich gespeichert.",
  "settings": "Um Änderungen an den Einstellungen anzuwenden, aktualisiere deinen Shop.",
  "toolbarError": "Die Änderungen konnten nicht gespeichert werden. Falls die aktuelle Sitzung abgelaufen ist, starte eine neue Sitzung. Öffne dazu den Editor erneut.",
  "toolbarSuccess": "Die Änderungen wurden gespeichert.",
  "branding-and-design": "Branding & design",
  "branding-and-design-tooltip": "Branding & design: Manage your logo, customize colors, typography, and more.",
  "design": "Design",
  "branding": "Branding",
  "item": "Item",
  "displayed-information": "Displayed information",
  "seo": "SEO Settings",
  "robots": "Robots",
  "tracking-and-analytics": "Tracking & analytics",
  "meta-data-defaults": "Meta data defaults",
  "custom-canonical-URL-for-item-pages": "Custom canonical URL for item pages",
  "item-URL-handling": "Item URL Handling",
  "social-media": "Social Media",
  "search-engines": "Improve product listings in search engines",
  "category": "Category Settings",
  "sorting": "Sorting",
  "checkout": "Checkout",
  "other-settings": "Other Settings",
  "search": "Search",
  "customize-search-results": "Customise search results",
  "general": "General settings",
  "security": "Security",
  "customer-management": "Customer Management",
  "b2b-commerce": "B2B Commerce",
  "performance": "Performance",
  "contact-form": "Contact Form",
  "shipping-information-page": "Shipping information page",
  "privacy": "Privacy",
  "filter.prices.price_asc": "Price ⬆",
  "filter.prices.price_desc": "Price ⬇",
  "filter.position_asc": "Position ⬆",
  "filter.position_desc": "Position ⬇",
  "analyzed.number.sorting_asc": "Variation number ⬆",
  "analyzed.number.sorting_desc": "Variation number ⬇",
  "filter.availabilityAverageDays_asc": "Availability ⬆",
  "filter.availabilityAverageDays_desc": "Availability ⬇",
  "filter.isMain_desc": "Main Variation First",
  "variationId_asc": "Variation ID ⬆",
  "variationId_desc": "Variation ID ⬇",
  "default.recommended_sorting": "Recommended",
  "item.id_asc": "Item ID ⬆",
  "item.id_desc": "Item ID ⬇",
  "texts.name1_asc": "Name A-Z",
  "texts.name1_desc": "Name Z-A",
  "sorting.price.avg_asc": "Price ⬆",
  "sorting.price.avg_desc": "Price ⬇",
  "variation.id_asc": "Variation ID ⬆",
  "variation.id_desc": "Variation ID ⬇",
  "variation.createdAt_desc": "Newest items",
  "variation.createdAt_asc": "Oldest items",
  "variation.availability.averageDays_asc": "Availability ⬆",
  "variation.availability.averageDays_desc": "Availability ⬇",
  "variation.number_asc": "Variation number ⬆",
  "variation.number_desc": "Variation number ⬇",
  "variation.updatedAt_asc": "Last update",
  "variation.updatedAt_desc": "First update",
  "variation.position_asc": "Variation position ⬆",
  "variation.position_desc": "Variation position ⬇",
  "item.manufacturer.externalName_asc": "Manufacturer A-Z",
  "item.manufacturer.externalName_desc": "Manufacturer Z-A",
  "item.feedbackDecimal_asc": "Item reviews ⬆",
  "item.feedbackDecimal_desc": "Item reviews ⬇",
  "item.score": "Relevance",
  "stock.net_asc": "Stock ⬆",
  "stock.net_desc": "Stock ⬇",
  "item.manufacturer.position_asc": "Manufacturer position ⬆",
  "item.manufacturer.position_desc": "Manufacturer position ⬇",
  "item.random": "Random",
  "notSelected": "Not selected",
  "custom-css": "Custom CSS",
  "custom-js": "Custom JavaScript",
  "custom-meta-tags": "Custom Meta tags",
  "external-scripts": "External Scripts & Styles",
  "custom-code": "Custom Code",
  "block-reset-success": "Blocks reset successfully. Please refresh the page.",
  "block-reset-error": "An error occurred while resetting the blocks. {error}",
  "unsaved-changes-confirm": "You have unsaved changes. Are you sure you want to leave?",
  "block-edit-homepage-only": "You can only edit the {blockName} on the homepage"
}
